import { memo } from "react";
import { AlertCircle } from "lucide-react";

interface LoginErrorMessageProps {
  error: string;
  checkCredentialsText: string;
}

export const LoginErrorMessage = memo(function LoginErrorMessage({ 
  error, 
  checkCredentialsText 
}: LoginErrorMessageProps) {
  return (
    <div
      role="alert"
      data-testid="login-error-alert"
      className="rounded-lg bg-destructive/10 border border-destructive/20 p-4 flex items-start gap-3"
    >
      <AlertCircle className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm font-medium text-destructive">{error}</p>
        <p className="text-xs text-destructive/80 mt-1">
          {checkCredentialsText}
        </p>
      </div>
    </div>
  );
});

